import ApiEs from '../services/elastic/es'
import { ICompare } from '../interfaces';

export const fetchAllData = async (state: any, dispatch: any) => {
  const results = await ApiEs.getAllData(state);
  dispatch({
    type: "LOAD_DATA",
    payload: results
  });
  dispatch({
    type: "LOAD_SUBCATEGORIES",
    payload: results
  });
};


export const changePageAction = (currentPage: number, dispatch: any) => {
  dispatch({
    type: 'CHANGE_CURRENT_PAGE',
    payload: currentPage
  });
};

export const searchAction = (pattern: string, dispatch: any) => {
  dispatch({
    type: "SEARCH",
    payload: pattern
  });
};

// Crée le loader
export const toggleLoading = (value: any, dispatch: any) => {
  dispatch({
    type: 'IS_LOADING',
    payload: value
  });
};

// Ajouter / Supprimer des favoris
export const toggleFavAction = (result: any, state: any, dispatch: any) => {
  const resultInFavorites = state.favs.includes(result);
  let dispatchObj = {
    type: 'ADD_FAV',
    payload: result
  };
  if (resultInFavorites) {
    dispatchObj = {
      type: 'REMOVE_FAV',
      payload: state.favs.filter((fav: ICompare) => fav._id !== result._id)
    };
  }
  
  dispatch(dispatchObj);
};

// Remise à zéro des favoris
export const razFavAction = (dispatch: any) => {
  dispatch({
    type: 'RAZ_FAV',
    payload: []
  });
};

export const toggleCompareAction = (isActive: any, dispatch: any) => {
  let dispatchObj = {
    type: 'ADD_COMPARE',
    payload: true
  };
  if (isActive === true) {
    dispatchObj = {
      type: 'REMOVE_COMPARE',
      payload: false
    };
  }
  
  dispatch(dispatchObj);
};

export const toggleDetailAction = (show: any, item: any, dispatch: any) => {
  dispatch({
    type: 'DETAIL_PAGE',
    payload: {
      show: show,
      content: item
    }
  });
}
 
export const toggleCategories = (category: any, state: any, dispatch: any) => {  
  let [ key, value ] = category.key.split(':')
  let filters: any = {}
  filters[key] = value

  let dispatchObj = {
    type: 'FILTER_ADD_CATEGORY',
    payload: filters
  };

  if (state.filterCategories.length !== 0) {
    const results = state.filterCategories.filter((c: any) => Object.getOwnPropertyNames(c)[0] === key);
    if (results.length !== 0) {
      dispatchObj = {
        type: 'FILTER_REMOVE_CATEGORY',
        payload: state.filterCategories.filter((c: any) => Object.getOwnPropertyNames(c)[0] !== key)
      };
    }
  }
  
  dispatch(dispatchObj);
};

export const removeCategories = (category: any, state: any, dispatch: any) => {  
  let [ key, value ] = category.key.split(':')
  let filters: any = {}
  filters[key] = value

  const results = state.filterCategories.filter((c: any) => Object.getOwnPropertyNames(c)[0] === key);
  if (results.length !== 0) {
    dispatch({
      type: 'FILTER_REMOVE_CATEGORY',
      payload: state.filterCategories.filter((c: any) => Object.getOwnPropertyNames(c)[0] !== key)
    })
  }
};

export const show1YCol = (show: boolean, dispatch: any) => {  
  dispatch({
    type: 'SHOW1COL',
    payload: show
  });
};

export const show3YCol = (show: boolean, dispatch: any) => {  
  dispatch({
    type: 'SHOW3COL',
    payload: show
  });
};

export const toggleSubCategories = (taxo: any, state: any, dispatch: any) => {  
  // let [ key, value ] = category.key.split(':')
  let key = taxo.filter
  let value = taxo.key
  let filters: any = { [key]: value }

  let dispatchObj = {
    type: 'FILTER_ADD_SUBCATEGORY',
    payload: filters
  };

  if (state.filterSubCategories.length !== 0) {
    const results = state.filterSubCategories.filter((c: any) => c[key] === value);
    if (results.length !== 0) {
      dispatchObj = {
        type: 'FILTER_REMOVE_SUBCATEGORY',
        payload: state.filterSubCategories.filter((c: any) => c[key] !== value)
      };
    }
    if (!value && key) {
      let current_sub = state.filterSubCategories.filter(
        (c: any) => Object.keys(c) == key
      );
      if (current_sub.length !== 0) {
        dispatchObj = {
          type: "FILTER_REMOVE_SUBCATEGORY",
          payload: state.filterSubCategories.filter(
            (c: any) => Object.keys(c) != key
          )
        };
      }
    }
    // if(!value) {
    //   current
    // }
  }
  
  dispatch(dispatchObj);
};

export const toggleParams = (params: any, state: any, dispatch: any) => {
  let key = Object.keys(params)[0];
  let value = Boolean(Object.values(params)[0]);

  let dispatchObj = {
    type: 'FILTER_ADD_PARAMS',
    payload: params
  };

  // Delete params
  if (!value) {
    const results = state.filterParams.filter((c: any) => Object.getOwnPropertyNames(c)[0] === key);
    if (results.length !== 0) {
      dispatchObj = {
        type: 'FILTER_REMOVE_PARAMS',
        payload: state.filterParams.filter((c: any) => Object.getOwnPropertyNames(c)[0] !== key)
      };
    }
  }

  dispatch(dispatchObj);
};

export const toggleIsin = async (text: string, dispatch: any) => {
  const result = await ApiEs.getIsin(text);
  dispatch({
    type: 'LOAD_DATA',
    payload: result
  });
};

